<template>
  <div class="inspectionRecords">
    <el-row>
      <el-col class="form">
        <el-form :model="formData" label-width="80px">
          <!-- <el-form-item label="检测机构">
            <patientTree @input="input"></patientTree>
          </el-form-item>
          <el-form-item label="三级医师">
            <el-input v-model="formData.doctorLevel3Name"></el-input>
          </el-form-item>
          <el-form-item label="风险等级">
            <el-select v-model="formData.risk" placeholder="全部">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="绿色" value="1"></el-option>
              <el-option label="黄色" value="2"></el-option>
              <el-option label="红色" value="3"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="血糖类型">
            <el-select v-model="formData.measureStatus" placeholder="全部">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="空腹血糖" value="空腹血糖"></el-option>
              <el-option label="早餐后" value="早餐后"></el-option>
              <el-option label="早餐后2小时" value="早餐后2小时"></el-option>
              <el-option label="午餐前" value="午餐前"></el-option>
              <el-option label="午餐后两小时" value="午餐后两小时"></el-option>
              <el-option label="晚餐前" value="晚餐前"></el-option>
              <el-option label="晚餐后两小时" value="晚餐后两小时"></el-option>
              <el-option label="随机" value="随机"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="血糖危险">
            <el-select v-model="formData.critical" placeholder="全部">
              <el-option label="全部" :value="null"></el-option>
              <el-option label="危急值" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="血糖范围">
            <el-input-number size="small" v-model="formData.bloodsugarLe" :min="1" :max="30"
              label="最小值"></el-input-number>
            <el-input-number size="small" v-model="formData.bloodsugarGe" :min="1" :max="30"
              label="最大值"></el-input-number>
          </el-form-item> -->
          <el-form-item label="测量时间">
            <el-date-picker v-model="valueData" type="daterange" align="right" unlink-panels range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="margin-left: 40px" @click="getBloodSugarList">查询</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col>
        <el-table class="inspectionTable" :row-class-name="tableRowClassName" v-loading="listLoading" :data="manageList"
          fit>
          <el-table-column width="150px" align="center" label="测量时间">
            <template slot-scope="scope">
              <span>{{ scope.row.time }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.measurerName }}</span>
            </template>
          </el-table-column>

          <el-table-column width="170px" align="center" label="身份证号">
            <template slot-scope="scope">
              <span>{{ scope.row.measurerIdentityCard }}</span>
            </template>
          </el-table-column>

          <el-table-column width="120px" align="center" label="血糖类型">
            <template slot-scope="scope">
              <span>{{ scope.row.measureStatus }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="血糖值">
            <template slot-scope="scope">
              <span>{{ scope.row.bloodSugar }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="责任医师">
            <template slot-scope="scope">
              <span>{{ scope.row.doctorResponse }}</span>
            </template>
          </el-table-column>

          <el-table-column width="156" align="center" label="三级医师（糖）">
            <template slot-scope="scope">
              <span>{{ scope.row.doctorLevel3Name }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="测量机构">
            <template slot-scope="scope">
              <span>{{ scope.row.dataSources }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊次数">
            <template slot-scope="scope">
              <span>{{ scope.row.coDiagCount }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="协诊状态">
            <template slot-scope="scope">
              <span>{{ scope.row.codiagStatus == 0 ? "未协诊" : "已协诊" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.pageNum" :limit.sync="listQuery.pageSize"
          @pagination="turnToPage" />

        <new-follow-up v-if="newFollowUpVisible" ref="NewFollowUpRef"></new-follow-up>

        <patient-detail v-if="patientDetailVisible" ref="PatientDetailRef"></patient-detail>
        <onetalkConsultationDialog @upDataList="upDataList" v-if="onetalkConsultationVisialbe"
          ref="onetalkConsultationRef">
        </onetalkConsultationDialog>
        <!-- <diagnoseDialog v-if="diagnoseDialog" ref="diagnoseDialogRef"></diagnoseDialog> -->
      </el-col>
    </el-row>

  </div>
</template>

<script>
import { getBloodSugarList, getUserInfos, turnToBloodSugarList, getSearchList, getFollowupValue, getListByTime } from "@/api/health/Patients";
import Pagination from "@/components/Pagination";
import patientDetail from "@/views/patient/patientDetail";
// import onetalkConsultationDialog from "@/views/cloudhealth/dualReferral/glucoseRecordDialogs/onetalkConsultationDialog.vue";
// import diagnoseDialog from "@/views/cloudhealth/dualReferral/glucoseRecordDialogs/diagnoseDialog.vue";
// import newFollowUp from "@/views/cloudhealth/disease/BloodGlucose/newFollowUp.vue";

import patientTree from '@/components/selectTree';

export default {
  components: { Pagination, patientTree, patientDetail },
  props: {
    pInfo: null
  },
  data() {
    return {
      // newFollowUpVisible: false,
      patientDetailVisible: false,
      // onetalkConsultationVisialbe: false,
      // diagnoseDialogVisialbe: false,
      formData: {
        // doctorLevel3Name: null,
        // risk: null,
        // critical: null,
        // bloodsugarLe: 1,
        // bloodsugarGe: 30,
        measurerName: null,
        idcard: null,
        // codiagStatus: null,
        // measureStatus: null,
        // codiagCountGe: null,
        // managerHospitals: [],
        startTime: null,
        endTime: null
      },
      data: [],
      valueData: null,
      manageList: [],
      listLoading: false,
      total: 0,
      listQuery: {
        pageNum: 1,
        pageSize: 10
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
    }
  },
  created() {
    this.getBloodSugarList();
  },
  methods: {
    // 新建随访记录
    onAdd(row) {
      var params = {
        idcard: row.measurerIdentityCard,
        serviceType: "糖尿病"
      }

      var data = {
        idcard: row.measurerIdentityCard,
        status: "已完成"
      }
      getFollowupValue(params).then(res => {
        if (res.msg == "success") {
          // if (res.data) {
          if (res.data) {
            row.ehr.bloodSuger = res.data.bloodSuger;
            row.ehr.nextFollowupTime = res.data.nextFollowupTime;
            row.ehr.bloodsugarTime = res.data.startTime;
          }

          getListByTime(data).then(Response => {
            if (Response.msg == "success") {
              const data = Object.assign({}, Response.data);
              if (data.hasOwnProperty("records") && data.records.length != 0) {
                Response.data.records = Response.data.records.filter((item) => {
                  return item.status == "已完成";
                });
                row.ehr.records = Response.data.records[0];
              }
              this.newFollowUpVisible = true;
              this.$nextTick(() => {
                this.$refs.NewFollowUpRef.init(row.ehr);
              });
            }
          }).catch((error) => {
            console.log(error);
          })
          // } else {
          //   this.$message({
          //     message: "该患者暂无血糖值，请获取最新血糖值！",
          //     type: "error"
          //   })
          // }
        }
      })
    },
    // 跳转诊断列表
    diagnoseDialog(row) {
      // if (!row.ehr) {
      //   this.$message({
      //     message: "该患者尚未建立个人档案，请先建立！",
      //     type: "warning"
      //   })
      // } else {
      //   this.diagnoseDialogVisialbe = true;
      //   this.$nextTick(() => {
      //     this.$refs['diagnoseDialogRef'].init(row);
      //   })
      // }
    },
    // 跳转协诊记录表
    onetalkConsultationDialog(row) {
      // if (!row.ehr) {
      //   this.$message({
      //     message: "该患者尚未建立个人档案，请先建立！",
      //     type: "warning"
      //   })
      // } else {
      //   this.onetalkConsultationVisialbe = true;
      //   this.$nextTick(() => {
      //     this.$refs['onetalkConsultationRef'].init(row);
      //   })
      // }
    },
    upDataList() {
      this.getBloodSugarList();
    },
    getBloodSugarList() {
      // if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
      //   this.$message({
      //     message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
      //     type: "error"
      //   })
      //   return;
      // }
      if (this.valueData != null) {
        this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
        this.formData.endTime = this.valueData[0] ? this.getParseDate(this.valueData[1], 2) : null;
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      const params = this.formData;
      params.measurerName = this.pInfo.name;
      params.idcard = this.pInfo.idcard;
      this.listLoading = true;
      getBloodSugarList(params).then(res => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      })
    },
    // 跳转至相应病人档案详情页
    patientsDetail(row) {
      if (!row.ehr) {
        this.$message({
          message: "该患者尚未建立个人档案，请先建立！",
          type: "warning"
        })
      } else {
        this.patientDetailVisible = true;
        this.$nextTick(() => {
          this.$refs["PatientDetailRef"].init(row.ehr);
        });
      }
    },
    // 获取系统时间
    getSystemTime() {
      var newTime = new Date(time);
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 日期格式转化
    getParseDate(time, type) {
      if (type == 1) {
        var newTime = new Date(time);
      } else if (type == 2) {
        var newTime = new Date(((new Date(time) / 1000) + 86400) * 1000);
      }
      // 获取完整的年份(4位)
      var year = newTime.getFullYear();
      // 获取月份(0-11,0代表1月)
      var month = newTime.getMonth() + 1;
      // 获取日期(1-31)
      var date = newTime.getDate();

      return year + "-" + (month < 10 ? '0' + month : month) + "-" + (date < 10 ? '0' + date : date);
    },
    // 获取机构数组
    input(value) {
      // this.formData.managerHospitals = value;
    },
    // 导航跳转查询列表页
    turnToPage() {
      // if (this.formData.bloodsugarLe > this.formData.bloodsugarGe) {
      //   this.$message({
      //     message: "血糖范围左侧值必须小于右侧值，请重选后再次查询！",
      //     type: "error"
      //   })
      //   return;
      // }
      if (this.valueData != null) {
        this.formData.startTime = this.valueData[0] ? this.getParseDate(this.valueData[0], 1) : null;
        this.formData.endTime = this.valueData[1] ? this.getParseDate(this.valueData[1], 2) : null;
      } else {
        this.formData.startTime = null;
        this.formData.endTime = null;
      }
      let params = Object.assign({}, this.listQuery, this.formData)
      params.measurerName = this.pInfo.name;
      params.idcard = this.pInfo.idcard;

      this.listLoading = true;
      turnToBloodSugarList(params).then((res) => {
        this.listLoading = false;
        if (res.msg == "success") {
          this.manageList = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    // 修改条纹颜色
    tableRowClassName({ row, rowIndex }) {
      if (row.risk == 3) {
        return 'light-row'
      } else if (row.risk == 2) {
        return 'aterrimus-row'
      } else if (row.risk == 1) {
        return 'green-row'
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.inspectionTable {
  ::v-deep {
    .light-row {
      background: rgba(255, 0, 0, 0.579) !important;
    }

    .aterrimus-row {
      //黄
      background: yellow !important;
    }

    .green-row {
      background: greenyellow;
    }

    .el-table__cell {
      height: 50px !important;
    }
  }

}

.form ::v-deep {
  .el-form-item {
    display: inline-flex;
  }

  .el-input--medium .el-input__inner {
    width: 209px !important;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>